import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { ConfigPedidoForm, ConfigPedidoList } from 'pages/compra/configuracao-pedido/components';
import { ConfigPedidoStepProvider } from 'pages/compra/configuracao-pedido/contexts/ConfigPedidoStepContext';

export function ConfiguracaoPedidoCompraForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPRA_PEDIDO_CONFIGURACAO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ConfigPedidoStepProvider>
            <ConfigPedidoForm />
        </ConfigPedidoStepProvider>
    );
}

export function ConfiguracaoPedidoCompraList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPRA_PEDIDO_CONFIGURACAO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <ConfigPedidoList />
        </ListagemProvider>
    );
}
